import React from 'react';
import { Link } from 'react-router-dom';
export function Footer() {
  return <footer className="bg-navy text-cream pt-24 pb-12 px-6 md:px-12 border-t border-cream/10" data-id="element-75">
      <div className="max-w-7xl mx-auto" data-id="element-76">
        <div className="grid grid-cols-1 md:grid-cols-12 gap-12 lg:gap-8 mb-24" data-id="element-77">
          <div className="md:col-span-6 lg:col-span-5" data-id="element-78">
            <img src="https://cdn.magicpatterns.com/uploads/uJ1Trq7SuNbdwizbCqPRU7/launchcave_logo.png" alt="LaunchCave Logo" className="h-10 w-auto object-contain mb-8 brightness-0 invert" data-id="element-79" />
            <h4 className="text-2xl font-serif mb-6 text-balance" data-id="element-80">
              Building the next generation of software, one idea at a time.
            </h4>
            {/*<a
             href="mailto:hello@launchcave.com"
             className="text-orange hover:text-white transition-colors text-lg"
             >
             hello@launchcave.com
             </a>*/}
          </div>

          <div className="md:col-span-3 lg:col-span-2 lg:col-start-8" data-id="element-81">
            <h5 className="font-semibold tracking-wider uppercase text-sm text-cream/50 mb-6" data-id="element-82">
              Studio
            </h5>
            <ul className="space-y-4" data-id="element-83">
              <li data-id="element-84">
                <a href="#studio" className="hover:text-orange transition-colors" data-id="element-85">
                  Studio
                </a>
              </li>
              <li data-id="element-86">
                <a href="#approach" className="hover:text-orange transition-colors" data-id="element-87">
                  Approach
                </a>
              </li>
              <li data-id="element-88">
                <a href="#ventures" className="hover:text-orange transition-colors" data-id="element-89">
                  Ventures
                </a>
              </li>
            </ul>
          </div>
          {/*
           <div className="md:col-span-3 lg:col-span-2">
           <h5 className="font-semibold tracking-wider uppercase text-sm text-cream/50 mb-6">
           Social
           </h5>
           <ul className="space-y-4">
           <li>
           <a href="#" className="hover:text-orange transition-colors">
            Twitter / X
           </a>
           </li>
           <li>
           <a href="#" className="hover:text-orange transition-colors">
            LinkedIn
           </a>
           </li>
           <li>
           <a href="#" className="hover:text-orange transition-colors">
            GitHub
           </a>
           </li>
           <li>
           <a href="#" className="hover:text-orange transition-colors">
            Dribbble
           </a>
           </li>
           </ul>
           </div>
           */}
        </div>

        <div className="flex flex-col md:flex-row justify-between items-center pt-8 border-t border-cream/10 text-sm text-cream/40" data-id="element-90">
          <p data-id="element-91">
            © {new Date().getFullYear()} LaunchCave LLC. All rights reserved.
          </p>
          <div className="flex gap-6 mt-4 md:mt-0" data-id="element-92">
            <Link to="/privacy" className="hover:text-cream transition-colors" data-id="element-93">
              Privacy Policy
            </Link>
            <Link to="/terms" className="hover:text-cream transition-colors" data-id="element-94">
              Terms of Service
            </Link>
          </div>
        </div>
      </div>
    </footer>;
}